/**
 * External dependencies
 */
import React from 'react';
import page from 'page';

/**
 * Internal dependencies
 */
import ConnectionsMain from './main';
import Sidebar from './sidebar';

export const sidebar = (context, next) => {
    context.secondary = <Sidebar path={context.path} />
    next();
}

export const index = (context, next) => {
    context.primary = <ConnectionsMain />;
    next();
}